if (!customElements.get('speakon-home-hero')) {
  customElements.define('speakon-home-hero', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const dialog = this.querySelector('dialog');
      const video = dialog?.querySelector('video');
      if (!dialog || !video) return;

      this.querySelector('[data-open-demo]')?.addEventListener('click', () => {
        dialog.showModal();
        video.play().catch(() => { /* Native controls remain available if playback is blocked. */ });
      }, options);
      this.querySelector('[data-close-demo]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', (event) => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
      }, options);
      dialog.addEventListener('close', () => {
        video.pause();
        video.currentTime = 0;
      }, options);
    }

    disconnectedCallback() {
      this.querySelector('video')?.pause();
      this.events?.abort();
    }
  });
}
